/**
 * Footer tag chips on journey listing cards (`GroupProgramOffering`, `PrivateOffering`).
 * Group event About tags reuse the same treatment via `events/styles.js`.
 */

export const getOfferingCardTagChipsStyle = (theme) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  marginTop: 0,
  minWidth: 0,
  flex: '1 1 auto',
})

/** Plain `<span>` / non-MUI chip surface (group event About tags). */
export const getOfferingCardTagChipStyle = (theme) => ({
  display: 'inline-flex',
  alignItems: 'center',
  borderRadius: 999,
  height: 'auto',
  minHeight: 24,
  border: 'none',
  backgroundColor: theme.palette.blue.light25,
  color: '#8a94a3',
  fontWeight: 600,
  fontSize: theme.typography.pxToRem(11),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingTop: theme.spacing(0.25),
  paddingBottom: theme.spacing(0.25),
  lineHeight: 1.2,
  whiteSpace: 'nowrap',
})

/** MUI `Chip` className overrides for listing cards. */
export const getOfferingCardTagChipMuiStyle = (theme) => ({
  '&.MuiChip-root': {
    borderRadius: 999,
  },
  height: 'auto',
  minHeight: 24,
  border: 'none',
  backgroundColor: theme.palette.blue.light25,
  color: '#8a94a3',
  fontWeight: 600,
  fontSize: theme.typography.pxToRem(11),
  '& .MuiChip-label': {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    lineHeight: 1.2,
  },
})
